<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card class="pa-5 mb-5">
      <v-container>
        <v-row>
          <v-col cols="12" md="2" class="mr-5 mb-1">
            Patients Information
          </v-col>
          <v-col cols="12" md="8" class="mr-5 mb-1">
            <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                single-line
                hide-details
                outlined
                dense
                rounded
                label="Search here patients information."
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :search="search"

        :loading="loadingstatus"
    >
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                @click="get_appointment(item)"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
            >
              mdi-calendar
            </v-icon>
          </template>
          <span>Set Appoitnment</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                @click="get_ot_schedule(item)"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
            >
              mdi-calendar-clock
            </v-icon>
          </template>
          <span>Set OT Schedule</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon @click="create_invoice_investigation(item)" color="warning" dark v-bind="attrs" v-on="on">
              mdi-plus
            </v-icon>
          </template>
          <span>Create Invoice Investigation</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                @click="viewItem(item)"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
            >
              mdi-eye
            </v-icon>
          </template>
          <span>View Patient Details</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                @click="editItem(item)"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
            >
              mdi-pencil-box
            </v-icon>
          </template>
          <span>Edit Patient Data</span>
        </v-tooltip>
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";

export default {
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      returnUrl: atshq.defaults.headers.common.app_URL,
      search: "",
      loadingstatus: true,
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: true,
          value: "patient_id",
        },
        {text: "Name", value: "patient_name"},
        {text: "Phone", value: "patient_phone"},
        {text: "DOB", value: "patient_dob"},
        {text: "Gender", value: "patient_sex"},
        {text: "Blood Group", value: "patient_blood_group"},
        {text: "Reg. Date", value: "admission_date"},

        {text: "Referral", value: "corporate_client.ps_name"},
        {text: "Action", value: "actions", sortable: false},
      ],
      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Patients",
          disabled: true,
          href: "patients",
        },
      ],
    };
  },
  // Fetches posts when the component is created.
  created() {
    atshq.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("token");
    this.initialize();
  },
  watch: {
    search() {
      if (this.search) {
        this.patientListSearch();
      }
    },
  },
  mounted() {
    if (this.search) {
      this.patientListSearch();
    }
  },
  methods: {
    initialize() {
      atshq
          .get("patients/patients")
          .then((response) => {
            // JSON responses are automatically parsed.
            this.loadingstatus = false;
            this.desserts = response.data.data;
          })
          .catch((e) => {
            // this.errors.push(e);
            this.$noty.error("Oops, something went wrong!");
            this.$noty.error(" " + e);
          });
    },
    patientListSearch() {
      this.loadingstatus = true;
      atshq
          .get("patients/patient-list-search?search_data=" + this.search)
          .then((response) => {
            this.desserts = response.data.patients;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.$noty.error("Oops, something went wrong!");
            this.$noty.error(" " + e);
          });
    },
    editItem(item) {
      window.location.href = "patient-create/" + item.patient_id;
    },
    viewItem(item) {
      window.location.href = "patient-details/" + item.patient_id;
    },
    get_appointment(item) {
      window.location.href = "/appointment/create/" + item.patient_id;
    },
    get_ot_schedule(item) {
      window.location.href = "ot-module/schedule-create?patient_id=" + item.patient_id;
    },
    create_invoice(item) {
      window.open(
          this.returnUrl + "front_desk/invoice?patient_id=" + item.patient_id
      );
    },
    create_invoice_investigation(item) {
      window.open("/invoice/invoice-create-investigation/" + item.patient_id);
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },
  },
};
</script>